module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 45 44",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }